/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Liste } from '@mairistem/liste';

import { URL_SOUS_TYPES_ACTE_NAISSANCE } from '@/constants';
import { FiltresListeActes } from '@/components/Common';

import ActeNaissanceListeTable from './ActeNaissanceListeTable';

interface ActeNaissanceListeProps {
  actes?: Array<any>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSort?: any;
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeNaissanceListe = (props: ActeNaissanceListeProps) => {
  const {
    actes,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    sidebar,
    ...handlers
  } = props;

  const tableau = (
    <ActeNaissanceListeTable
      items={actes}
      loading={loading}
      count={count}
      perPage={perPage}
      onLoad={onLoad}
      onSort={onSort}
      sidebar={sidebar}
    />
  );

  return (
    <Liste
      title="Liste des actes de naissance"
      searchable
      search={{
        clearable: true,
        placeholder:
          "Rechercher par n° d'acte, nom ou prénoms de l'enfant ou de ses parents...",
      }}
      {...handlers}
    >
      <Liste.Content>
        {sidebar ? (
          tableau
        ) : (
          <FiltresListeActes urlSousTypes={URL_SOUS_TYPES_ACTE_NAISSANCE}>
            {tableau}
          </FiltresListeActes>
        )}
      </Liste.Content>
    </Liste>
  );
};

export default ActeNaissanceListe;
